// Event system for collection updates
export const COLLECTION_EVENTS = {
  QUERY_UPDATED: 'collection:query:updated',
  QUERY_CREATED: 'collection:query:created',
  QUERY_DELETED: 'collection:query:deleted',
  QUERY_MOVED: 'collection:query:moved',
  FOLDER_CREATED: 'collection:folder:created',
  FOLDER_UPDATED: 'collection:folder:updated',
  FOLDER_DELETED: 'collection:folder:deleted',
  COLLECTION_CREATED: 'collection:created',
  COLLECTION_UPDATED: 'collection:updated',
  COLLECTION_DELETED: 'collection:deleted',
} as const;

export interface CollectionEventDetail {
  collectionId: string;
  queryId?: string;
  folderId?: string;
  folderName?: string;
  targetCollectionId?: string;
  targetFolderId?: string;
  tabId?: string; // Optional tab ID for updating editor tabs
  queryName?: string; // Optional query name for tab updates
}

// Helper to dispatch collection events
export function dispatchCollectionEvent(eventType: string, detail: CollectionEventDetail) {
  window.dispatchEvent(new CustomEvent<CollectionEventDetail>(eventType, { detail }));
}

// Helper to subscribe to collection events
export function subscribeToCollectionEvent(
  eventType: string,
  handler: (event: CustomEvent<CollectionEventDetail>) => void
): () => void {
  const wrappedHandler = (event: Event) => {
    if (typeof CustomEvent !== 'undefined' && event instanceof CustomEvent) {
      handler(event as CustomEvent<CollectionEventDetail>)
    }
  };
  window.addEventListener(eventType, wrappedHandler as EventListener);
  return () => {
    window.removeEventListener(eventType, wrappedHandler as EventListener);
  };
}